<div class="full-screen-dialog">
  <button class="floating-close-button" [mat-dialog-close]>
    <svg-icon-sprite style="color:white;" [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'24px'">
    </svg-icon-sprite>
  </button>
  <h1 mat-dialog-title>
    <span class="px-heading-3">Choose a Native Nudge</span></h1>
  <mat-dialog-content class="scrollable-container">
    <div class="select-module-container" *ngIf="!moduleLoading">
      <div class="row ml-0 mr-0" *ngIf="moduleList.length">
        <div class="col-md-12 heading search-container">
          <app-expanding-search [placeholder]="'Search in Modules'" [required]="false" [searchText]="moduleSearchText"
            [regExp]="'^[a-zA-Z0-9-_]*$'" [landDirectlyOnInputField]="true" [debounceTimeInMs]="600"
            (valueChangeCallback)="queryTextChange($event)" [label]="'NAME'">
          </app-expanding-search>
        </div>
        <mat-radio-group [(ngModel)]="selectedModule">
          <div class="col-md-12 module-row radio-btn-options"
            *ngFor="let module of moduleList | filter: {name:moduleSearchText}">
            <div class="radio-btn">
              <mat-radio-button name="select-module-radio" [value]="module">
                <div class="mod-text">
                  <p class="table-row-text">{{module.name}}</p>
                  <span class="table-row-description">{{module.desc}}</span>
                </div>
              </mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
      </div>
      <div class="row ml-0 mr-0" *ngIf="!moduleList.length">
        <div class="col-md-12">
          <span class="table-heading">There are no Native Nudges to choose from. Please create a CNative Nudge and try
            again</span>
        </div>
      </div>
    </div>
    <div class="hansel-journey-loader" *ngIf="moduleLoading">
      <div class="align-absolute-center animate-flicker" style="position: relative; height: 400px">
        <img src="/assets/images/Loader-PX.svg" class="px-loader">
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions *ngIf="!moduleLoading">
    <div class="tag-section" *ngIf="selectedModule && selectedModule.name">
      <hansel-tag tagType="rounded" tagTxt="{{selectedModule.name}}" (tagRemoveCallback)="tagRemoveCallback($event)">
      </hansel-tag>
    </div>
    <button class="px-primary-btn-xs" mat-flat-button (click)="attachDeepConfigToModule()"
      [disabled]="!selectedModule || (selectedModule && !selectedModule.name)" [promiseBtn]="btnPromise">Finish</button>
    <span class="no-module-help" *ngIf="false">Can't find the Native Nudge?</span>
    <button class="link-btn float-right" mat-flat-button *ngIf="false">Create new Native Nudge using selected deep
      configs</button>
  </mat-dialog-actions>
</div>
